module.exports = __webpack_public_path__ + "media/images/items/anim-1-9c59fdcaaf5f707e9d00f873c64b278d.webp";